<template>
  <InputDropdown
    :value="timezone"
    :search-value="searchValue"
    :suggestions="timezoneSuggestions"
    :placeholder="'Select your timezone'"
    @input="(val) => $emit('onUpdate', val)"
    @focus="onFocus"
    @searchInput="onTimeZoneSearchInput"
    @onSelectSuggestion="onSelectSuggestion"
  />
</template>

<script>
import { getBrowserTimezone } from '~/helpers';
import timezones from '~/assets/data/timezones.json';

export default {
  components: {
    InputDropdown: () => import('~/components/input/InputDropdown')
  },

  props: {
    timezone: {
      type: [String, Object],
      default: null,
      required: false
    }
  },

  data() {
    return {
      searchValue: null
    };
  },

  computed: {
    timezoneSuggestions() {
      if (!this.searchValue || !this.searchValue.length) {
        return timezones;
      }
      // Return the results that match either fields
      return timezones.filter((value) => {
        const val = value.value
          .toLowerCase()
          .includes(this.searchValue.toLowerCase());
        const text = value.text
          .toLowerCase()
          .includes(this.searchValue.toLowerCase());
        const abr = value.abbr
          .toLowerCase()
          .includes(this.searchValue.toLowerCase());
        const utc = !!value.utc.find((u) => {
          return u.toLowerCase().includes(this.searchValue.toLowerCase());
        });
        return val || text || abr || utc;
      });
    }
  },

  mounted() {
    // If no timezone defined by default, set the browser one
    if (!this.timezone) {
      const match = getBrowserTimezone();
      if (match) {
        this.$emit('onUpdate', match);
      }
    }
  },

  methods: {
    onFocus() {
      this.searchValue = null;
    },

    onTimeZoneSearchInput(value) {
      this.searchValue = value;
      if (!value) {
        this.$emit('onUpdate', null);
      }
    },
    onSelectSuggestion(value) {
      this.$emit('onUpdate', value);
    }
  }
};
</script>
